import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExternalRegistrationService } from '@externalregistrationservice/external-registration.service';

@Component({
    selector: 'app-external-registration',
    templateUrl: './external-registration.component.html',
    styleUrls: ['./external-registration.component.css'],
    providers: [ExternalRegistrationService],
    standalone: false
})
export class ExternalRegistrationComponent implements OnInit {
  FirstName: string;
  LastName: string;
  Email: string;
  Password: string;
  ConfirmPassword: string;
  Address1: string;
  Address2: string;
  Phone1: string;
  Phone2: string;
  State: any;
  City: any;
  Country: any = null;
  Zipcode: string;
  Question: any;
  Answer: any;

  userid: string;

  StatesDetail: any = {};
  CountryDetail: any = {};
  CityDetail: any = {};
  QuestionDetail: any = {};
  SelectedStateID: number;
  SelectedCityID: number;
  ShowCityDD: boolean;

  showPasswordMatchErrorMsg: boolean;
  showAddress1ErrorMsg: boolean;
  showPhone1ErrorMsg: boolean;
  showPasswordErrorMsg: boolean;

  RegistrationModel: any = {};

  showPassword: boolean;
  showConfirmPassword: boolean;
  showConPasswordErrorMsg: boolean;
  showStateErrorMsg: boolean;
  showCityErrorMsg: boolean;
  showCountyErrorMsg: boolean;

  passwordPattern: string;
  isPasswordValid: boolean;
  isFormValid: boolean;
  //isSubmitButtonDisabled: boolean;
  isCurrentPasswordHidden: boolean;
  showQuestionErrorMsg: boolean;
  showAnswerErrorMsg: boolean;
  showZipcodeErrorMsg: boolean;
  filteredCountriesSingle: any[];
  country: any;

  constructor(private registrationService: ExternalRegistrationService, private router: Router
    , private route: ActivatedRoute) {

    this.showPassword = false;
    this.showConfirmPassword = false;
    this.showConPasswordErrorMsg = false;
    this.showStateErrorMsg = false;
    this.showCityErrorMsg = false;
    this.showCountyErrorMsg = false;
    this.passwordPattern = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#~$!@])[A-Za-z\d$#~$!@].{11,}';
    this.isPasswordValid = true;
    this.isFormValid = true;
    //this.isSubmitButtonDisabled = true;
    this.isCurrentPasswordHidden = true;
    this.showQuestionErrorMsg = false;
    this.showAnswerErrorMsg = false;
    this.showZipcodeErrorMsg = false;

  }

  ngOnInit() {
    this.FirstName = sessionStorage.getItem('firstname');
    this.LastName = sessionStorage.getItem('lastname');
    this.Email = sessionStorage.getItem('emailid');
    this.userid = sessionStorage.getItem('userid');

    // this.GetState();
    this.GetCity();
    this.getCountries();
    this.GetQuestion();
    this.ShowCityDD = false;
    this.showPasswordMatchErrorMsg = false;
    this.showAddress1ErrorMsg = false;
    this.showPhone1ErrorMsg = false;
    this.showPasswordErrorMsg = false;
    this.showConPasswordErrorMsg = false;
    this.showStateErrorMsg = false;

    this.showCityErrorMsg = false;
    this.showCountyErrorMsg = false;

  }


  Registration(event) {

    this.isFormValid = true;
    this.isCurrentPasswordHidden = true;
    this.showQuestionErrorMsg = false;
    if (this.Password === null || this.Password === undefined || this.Password === '') {
      this.showPasswordErrorMsg = true;
      this.isFormValid = false;
    } else {
      this.showPasswordErrorMsg = false;
      let res = this.Password.match(this.passwordPattern);

      if (res != null) {
        this.isPasswordValid = true;
      } else {
        this.isPasswordValid = false;
        this.isFormValid = false;
      }

      let lowercaseNewPassword = this.Password.toLowerCase();
      if (this.FirstName !== null && this.FirstName !== undefined && this.FirstName !== '') {
        if (lowercaseNewPassword.indexOf(this.FirstName.toLowerCase()) > -1) {
          this.isPasswordValid = false;
          this.isFormValid = false;
        }

      }
      if (this.LastName !== null && this.LastName !== undefined && this.LastName !== '') {
        if (lowercaseNewPassword.indexOf(this.LastName.toLowerCase()) > -1) {
          this.isPasswordValid = false;
          this.isFormValid = false;
        }
      }
    }
    if (this.ConfirmPassword === null || this.ConfirmPassword === undefined || this.ConfirmPassword === '') {
      this.showConPasswordErrorMsg = true;
      this.isFormValid = false;
    } else {
      this.showConPasswordErrorMsg = false;
      if (this.Password !== this.ConfirmPassword) {

        this.showPasswordMatchErrorMsg = true;
        this.isFormValid = false;

      } else {
        this.showPasswordMatchErrorMsg = false;
      }
    }

    if (this.Address1 === null || this.Address1 === undefined || this.Address1.trim() === '') {
      this.showAddress1ErrorMsg = true;
      this.isFormValid = false;
    } else {
      this.showAddress1ErrorMsg = false;
    }

    if (this.Phone1 === null || this.Phone1 === undefined || this.Phone1 === '') {
      this.showPhone1ErrorMsg = true;
      this.isFormValid = false;
    } else {
      this.showPhone1ErrorMsg = false;
    }
    if (this.State === null || this.State === undefined || this.State === '') {
      this.showStateErrorMsg = true;
    } else {
      this.showStateErrorMsg = false;
    }

    let cityPattern = new RegExp('[A-Za-z]{1,45}');

    if (this.City === null || this.City === undefined || this.City === '' || !cityPattern.test(this.City)) {
      this.showCityErrorMsg = true;
      this.isFormValid = false;
    } else {
      this.showCityErrorMsg = false;
    }




    if (this.Zipcode === null || this.Zipcode === undefined || this.Zipcode === '') {
      this.showZipcodeErrorMsg = true;
      this.isFormValid = false;
    } else {
      this.showZipcodeErrorMsg = false;
    }
    if (this.Country === null || this.Country === undefined || this.Country === '') {
      this.showCountyErrorMsg = true;
    } else {
      this.showCountyErrorMsg = false;
    }

    if (this.Question === null || this.Question === undefined || this.Question === '') {
      this.showQuestionErrorMsg = true;
      this.isFormValid = false;
    } else {
      this.showQuestionErrorMsg = false;
    }

    if (this.Answer === null || this.Answer === undefined || this.Answer.trim() === '') {
      this.showAnswerErrorMsg = true;
      this.isFormValid = false;
    } else {
      this.showAnswerErrorMsg = false;
    }

    if (this.isFormValid) {
      this.RegistrationModel.Firstname = this.FirstName;
      this.RegistrationModel.LastName = this.LastName;
      this.RegistrationModel.Email = this.Email;
      this.RegistrationModel.Password = this.Password;
      this.RegistrationModel.ConfirmPassword = this.ConfirmPassword;
      this.RegistrationModel.Address1 = this.Address1;
      this.RegistrationModel.Address2 = this.Address2;
      this.RegistrationModel.Phone1 = this.Phone1;
      this.RegistrationModel.Phone2 = this.Phone2;
      this.RegistrationModel.State = this.State;
      this.RegistrationModel.city = this.City;
      this.RegistrationModel.Zipcode = this.Zipcode;
      this.RegistrationModel.UserID = this.userid;
      this.RegistrationModel.QuestionID = this.Question.questionID;
      this.RegistrationModel.Answer = this.Answer;
      this.RegistrationModel.CountryID = this.Country.countrY_ID;

      //console.log(this.RegistrationModel);

      let Response;
      this.registrationService.SaveRegistration(this.RegistrationModel).subscribe(
        p => {
          Response = p;

          if (Response.status === 'Success') {
            //sessionStorage.setItem('AgencyID', Response.user.userAgencyID);
            sessionStorage.setItem('userRoleId', Response.user.userRoleID);
            sessionStorage.setItem('userType', 'E');
            this.router.navigate(['Invoice']);

          }
         else
      if (Response.status === 'PE') {
        this.isCurrentPasswordHidden = false;
      }
  }
      )
}
  }

GetState() {

  this.registrationService.GetState().subscribe(
    p => { this.StatesDetail = p; }
  );

}

getCountries() {

  this.registrationService.getCountries().subscribe(
    p => this.CountryDetail = p
  );

}

GetCity() {

  this.registrationService.GetCity(this.SelectedStateID).subscribe(
    p => { this.CityDetail = p }
  );

}

GetQuestion() {

  this.registrationService.GetQuestion().subscribe(
    p => { this.QuestionDetail = p; }
  );

}

valuechange(event) {
  if (this.Password !== this.ConfirmPassword) {
    this.showPasswordMatchErrorMsg = true;

  } else {
    this.showPasswordMatchErrorMsg = false;
  }

}

// resolved(captchaResponse: string) {
//   if (captchaResponse != null)
//     this.isSubmitButtonDisabled = false;
// }


toggleShowPassword() {
  this.showPassword = !this.showPassword;
}
toggleShowConfirmPassword() {
  this.showConfirmPassword = !this.showConfirmPassword;
}


clearValue() {
  this.Country = null;
}

Resetall() {
  this.Password = null;
  this.ConfirmPassword = null;
  this.Address1 = null;
  this.Address2 = null;
  this.Phone1 = null;
  this.Phone2 = null;
  this.State = null;
  this.City = null;
  this.Zipcode = null;
  this.Question = null;
  this.Answer = null;
  this.ShowCityDD = false;
  this.showPasswordMatchErrorMsg = false;
  this.showAddress1ErrorMsg = false;
  this.showPhone1ErrorMsg = false;
  this.showPasswordErrorMsg = false;
  this.showConPasswordErrorMsg = false;
  this.showStateErrorMsg = false;
  this.showCityErrorMsg = false;
  this.isPasswordValid = true;
  this.isFormValid = true;
  this.isCurrentPasswordHidden = true;
  this.showQuestionErrorMsg = false;
  this.showAnswerErrorMsg = false;
  this.showZipcodeErrorMsg = false;
  this.showCountyErrorMsg = false;
}

filterCountrySingle(event) {
  let query = event.query;
  this.filteredCountriesSingle = this.filterCountry(query, this.CountryDetail);

}

filterCountry(query, countries: any[]): any[] {
  let filtered: any[] = [];
  for (let i = 0; i < countries.length; i++) {
    let country = countries[i];
    if (country.countrY_NAME.toLowerCase().indexOf(query.toLowerCase()) === 0) {
      filtered.push(country);
    }
  }
  return filtered;
}
}